<!--
  2022-10-18 Matt 一元夺宝 https://trello.com/c/6eNauoGj
-->
<template>
  <div class="page">
    <TopBack :title="$t('lang.treasure.rupee1Treasure')" />
    <div class="tabList">
      <div class="tab" :class="{tabSelected: activeTab==='latest'}" @click="() => changeActiveTab('latest')">
        {{$t('lang.treasure.latest')}}
      </div>
      <div class="tab" :class="{tabSelected: activeTab==='history'}" @click="() => changeActiveTab('history')">
        {{$t('lang.treasure.treasureHistory')}}
      </div>
      <div class="tab" :class="{tabSelected: activeTab==='myTreasure'}" @click="() => changeActiveTab('myTreasure')">
        {{$t('lang.treasure.myTreasure')}}
      </div>
    </div>

    <div class="latestTab" v-if="activeTab==='latest'">
      <img
        :src='helpIcon'
        alt="helpIcon"
        class='helpIcon'
        @click="gotoRoute('/Treasure/Rules')"
      />

      <Loadmore
        :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
        :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
        :bottomLoadingText="$t('lang.loadingStatus.loading')"
        :auto-fill="true"
        :bottom-method="fetchLatestTreasures"
        :bottom-all-loaded="isAllLatestTreasuresLoaded"
        ref="LoadMoreLatest"
      >
        <div class="treasureItem" v-for="(item, index) in latestTreasures" :key="index">
          <div class="boughtTips" v-if="item.IsCurrentUserBought">
            {{ $t('lang.treasure.bought') }}
          </div>
          <div class="drawTime">
            {{ $t('lang.treasure.drawTime') }}:
            <span>{{ new Date(`${item.DrawTime}Z`).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', hour12: false, dateStyle: 'short', timeStyle: 'short' }) }}</span>
          </div>
          <div class="details">
            <img
              :src="item.ImageUrl"
              alt="treasure"
              @click="() => showTreasureIntro(item.intro)"
            >
            <div class="nameProgressBuy">
              <div class="name">
                {{ item.Name }}
              </div>
              <div class="progress">
                <div class="indicator">
                  {{ Math.min(item.TotalSoldShare, item.TotalShare) }}/{{ item.TotalShare }}
                </div>
                <Progress :value="Math.min(item.TotalSoldShare / item.TotalShare * 100, 100)" :bar-height="1" />
              </div>
              <div class="buy">
                <div>
                  <button class="subs" @click="() => subsQuantity(index)">
                    -
                  </button>
                  <label>
                    <input
                      type="text"
                      @input="onQuantityChange(index, item.MaxSharePerUser, $event)"
                      :value="quantity[index] || 1"
                    >
                  </label>
                  <button class="add" @click="() => addQuantity(index, item.MaxSharePerUser)">
                    +
                  </button>
                </div>
                <button class="buyButton" @click="() => buy(item.Id, index)">
                  {{$t('lang.treasure.buy')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Loadmore>

      <div class="emptyTips" v-if="!latestTreasures || latestTreasures.length === 0">
        {{$t('lang.treasure.emptyTips')}}
      </div>

      <div class="boughtResultModal" v-if="isBoughtResultModalShowing">
        <div class="title" v-if="boughtQuantityInModal===1">
          {{$t('lang.treasure.boughtSingleResultMessage')}}
        </div>
        <div class="title" v-else>
          {{$t('lang.treasure.boughtMultipleResultMessage')}}
        </div>

        <div class="tickets">
          <div class="ticket" v-for="(ticket, index) in boughtTicketsInModal" :key="index">
            {{ ticket }}
          </div>
        </div>

        <button class="closeButton" @click="closeBoughtResultModal">
          {{$t('lang.treasure.ok')}}
        </button>
      </div>
    </div>

    <div class="historyTab" v-if="activeTab==='history'">
      <div class="historyList">
        <div class="table">
          <Loadmore
            :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
            :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
            :bottomLoadingText="$t('lang.loadingStatus.loading')"
            :auto-fill="true"
            :bottom-method="fetchHistoryTreasures"
            :bottom-all-loaded="isAllHistoryTreasuresLoaded"
            ref="loadMoreHistoryTreasures"
          >
            <div class="treasureItem" v-for="(item, index) in historyTreasures" :key="index">
              <div
                class="boughtTips winningTips"
                v-if="item.DrawStatus === 'DONE' && item.MyNumbers.length > 0 && item.MyResult === 'Win'"
              >
                {{ $t('lang.treasure.win') }}
              </div>
              <div
                class="boughtTips losingTips"
                v-if="item.DrawStatus === 'DONE' && item.MyNumbers.length > 0 && item.MyResult === 'Loss'"
              >
                {{ $t('lang.treasure.lost') }}
              </div>
              <div class="drawTime">
                <span v-if="item.DrawStatus === 'DONE'">{{ $t('lang.treasure.drawTime') }}:</span>
                <span v-if="item.DrawStatus === 'MONEYBACK'">{{ $t('lang.treasure.moneyBack') }}:</span>
                <span>{{ new Date(`${item.DrawTime}Z`).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', hour12: false, dateStyle: 'short', timeStyle: 'short' }) }}</span>
              </div>
              <div class="details">
                <img
                  :src="item.ImageUrl"
                  alt="treasure"
                  @click="() => showTreasureIntro(item.intro)"
                >
                <div class="nameAndNumbers">
                  <div class="name">
                    {{ item.Name }}
                  </div>
                  <div class="winningNumber" v-if="item.DrawStatus === 'DONE'">
                    {{ $t('lang.treasure.winningNumber') }}:
                    {{ item.DrawNumber }}
                  </div>
                  <div
                    class="myNumbers"
                    v-if="item.MyNumbers.length > 0"
                    @click="() => showHistoryBoughtResultModal(item.MyNumbers, item.DrawNumber)"
                  >
                    {{ $t('lang.treasure.myNumbers') }}
                  </div>
                </div>
              </div>
            </div>
          </Loadmore>
          <div class="emptyTips" v-if="!historyTreasures || historyTreasures.length === 0">
            {{$t('lang.treasure.emptyTips')}}
          </div>
        </div>
      </div>
      <div class="boughtResultModal" v-if="isHistoryBoughtResultModalShowing">
        <div class="tickets">
          <div
            class="ticket"
            :class="{hitTicket: ticket === drawNumberOfSelectedHistory, lossTicket: ticket !== drawNumberOfSelectedHistory}"
            v-for="(ticket, index) in boughtTicketsInModal"
            :key="index"
          >
            {{ ticket }}
          </div>
        </div>

        <button class="closeButton" @click="closeHistoryBoughtResultModal">
          {{$t('lang.treasure.ok')}}
        </button>
      </div>
    </div>

    <div class="myTreasureTab" v-if="activeTab==='myTreasure'">
      <div class="myTreasures">
        <div class="legend">
          <span>
            {{$t('lang.treasure.myTreasure')}}
          </span>
        </div>
        <div class="table">
          <div class="header">
            <div class="drawTime">{{$t('lang.treasure.drawTime')}}</div>
            <div class="myNumber">{{$t('lang.treasure.myNumber')}}</div>
            <div class="treasure">{{$t('lang.treasure.treasure')}}</div>
            <div class="status">{{$t('lang.treasure.status')}}</div>
          </div>
          <Loadmore
            :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
            :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
            :bottomLoadingText="$t('lang.loadingStatus.loading')"
            :auto-fill="true"
            :bottom-method="fetchMyWonTreasureShares"
            :bottom-all-loaded="isAllMyWonTreasureSharesLoaded"
            ref="loadMoreMyWonTreasureShares"
          >
            <div class="myTreasureItem" v-for="(item, index) in myWonTreasureShares" :key="index">
              <div class="drawTime">
                <span>{{ new Date(`${item.DrawTime}Z`).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', hour12: false, dateStyle: 'short', timeStyle: 'short' }) }}</span>
              </div>
              <div class="myNumber">
                {{ item.MyNumber }}
              </div>
              <div class="treasure">
                {{ item.Name }}
              </div>
              <div class="status">
                <span v-if="item.ExpressNo">{{ item.ExpressNo }}</span>
                <span v-else>{{ item.RewardStatus}}</span>
              </div>
            </div>
          </Loadmore>
          <div class="emptyTips" v-if="!myWonTreasureShares || myWonTreasureShares.length === 0">
            {{$t('lang.treasure.emptyTips')}}
          </div>
        </div>
      </div>
      <div class="myAddress">
        <div class="label">My Address:</div>
        <label>
          <input type="text" v-model="myAddress">
        </label>
        <button class="submitButton" @click="changeAddress">
          {{$t('lang.treasure.submit')}}
        </button>
      </div>
      <div class="myHistory">
        <div class="legend">
          <span>
            {{$t('lang.treasure.myHistory')}}
          </span>
        </div>
        <div class="table">
          <div class="header">
            <div class="drawTime">{{$t('lang.treasure.drawTime')}}</div>
            <div class="myNumber">{{$t('lang.treasure.myNumber')}}</div>
            <div class="treasure">{{$t('lang.treasure.treasure')}}</div>
            <div class="status">{{$t('lang.treasure.status')}}</div>
          </div>
          <Loadmore
            :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
            :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
            :bottomLoadingText="$t('lang.loadingStatus.loading')"
            :auto-fill="true"
            :bottom-method="fetchMyAllTreasureShares"
            :bottom-all-loaded="isAllMyAllTreasureSharesLoaded"
            ref="loadMoreMyAllTreasureShares"
          >
            <div
              class="myTreasureItem"
              :class="{win: item.DrawStatus === 'WIN', loss: item.DrawStatus === 'LOSS'}"
              v-for="(item, index) in myAllTreasureShares"
              :key="index"
            >
              <div class="drawTime">
                <span>{{ new Date(`${item.DrawTime}Z`).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', hour12: false, dateStyle: 'short', timeStyle: 'short' }) }}</span>
              </div>
              <div class="myNumber">
                {{ item.MyNumber }}
              </div>
              <div class="treasure">
                {{ item.Name }}
              </div>
              <div class="status">
                <span v-if="item.DrawNumber === item.MyNumber && item.ExpressNo">{{ item.ExpressNo }}</span>
                <span v-else-if="item.DrawNumber === item.MyNumber">{{ item.RewardStatus}}</span>
                <span v-else>{{ item.DrawStatus}}</span>
              </div>
            </div>
          </Loadmore>
          <div class="emptyTips" v-if="!myAllTreasureShares || myAllTreasureShares.length === 0">
            {{$t('lang.treasure.emptyTips')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Progress, Loadmore, Toast} from 'mint-ui'
import TopBack from '@/components/TopBack/index'

import helpIcon from '@/assets/images/common/help.svg'
import request from '@/service'
import { fetchCurrency } from '@/constant'

export default {
  name: 'Treasure',
  components: {
    TopBack,
    Progress,
    Loadmore
  },
  data () {
    return {
      helpIcon,
      fetchCurrency,
      activeTab: 'latest',
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      latestTreasures: [],
      quantity: {},
      isBoughtResultModalShowing: false,
      boughtQuantityInModal: 1,
      boughtTicketsInModal: [],
      drawNumberOfSelectedHistory: null,
      isAllLatestTreasuresLoaded: false,
      historyTreasures: [],
      isAllHistoryTreasuresLoaded: false,
      isHistoryBoughtResultModalShowing: false,
      myWonTreasureShares: [],
      isAllMyWonTreasureSharesLoaded: false,
      myAllTreasureShares: [],
      isAllMyAllTreasureSharesLoaded: false,
      myAddress: ''
    }
  },
  mounted () {
    this.fetchAddress()
  },
  methods: {
    changeActiveTab (tab) {
      this.activeTab = tab
      this.closeBoughtResultModal()
      this.closeHistoryBoughtResultModal()
    },
    fetchLatestTreasures () {
      const userUniqueId = this.userInfo.UserId
      const DrawTime = this.latestTreasures.length > 0 ? this.latestTreasures[this.latestTreasures.length - 1].DrawTime : null
      let url = `/innovation/treasures/latest?UserUniqueId=${userUniqueId}`
      if (DrawTime != null) {
        url = `/innovation/treasures/latest?UserUniqueId=${userUniqueId}&DrawTime=${DrawTime}`
      }

      request('get', url).then(res => {
        if (res.length > 0) {
          this.latestTreasures = this.latestTreasures.concat(res)
          if (res.length < 10) {
            this.isAllLatestTreasuresLoaded = true
          }
        } else {
          this.isAllLatestTreasuresLoaded = true
        }
        this.$refs.LoadMoreLatest.onBottomLoaded()
      }).catch(err => {
        console.log(err)
      })
    },
    fetchSoldSharesCount (treasureId, itemIndex) {
      const url = `/innovation/treasures/sold-shares-count?TreasureId=${treasureId}`
      request('get', url)
        .then(count => {
          this.latestTreasures[itemIndex].TotalSoldShare = count
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchHistoryTreasures () {
      const userUniqueId = this.userInfo.UserId
      const DrawTime = this.historyTreasures.length > 0 ? this.historyTreasures[this.historyTreasures.length - 1].DrawTime : null
      const url = `/innovation/treasures/history?UserUniqueId=${userUniqueId}&DrawTime=${DrawTime}`

      request('get', url).then(res => {
        if (res.length > 0) {
          this.historyTreasures = this.historyTreasures.concat(res)
          if (res.length < 10) {
            this.isAllHistoryTreasuresLoaded = true
          }
        } else {
          this.isAllHistoryTreasuresLoaded = true
        }
        this.$refs.loadMoreHistoryTreasures.onBottomLoaded()
      }).catch(err => {
        console.log(err)
      })
    },
    fetchMyWonTreasureShares () {
      const userUniqueId = this.userInfo.UserId
      const CreateTime = this.myWonTreasureShares.length > 0 ? this.myWonTreasureShares[this.myWonTreasureShares.length - 1].CreateTime : null
      const url = `/innovation/treasures/my-treasure-shares?UserUniqueId=${userUniqueId}&CreateTime=${CreateTime}&WonOnly=true`

      request('get', url).then(res => {
        if (res.length > 0) {
          this.myWonTreasureShares = this.myWonTreasureShares.concat(res)
          if (res.length < 10) {
            this.isAllMyWonTreasureSharesLoaded = true
          }
        } else {
          this.isAllMyWonTreasureSharesLoaded = true
        }
        this.$refs.loadMoreMyWonTreasureShares.onBottomLoaded()
      }).catch(err => {
        console.log(err)
      })
    },
    fetchMyAllTreasureShares () {
      const userUniqueId = this.userInfo.UserId
      const CreateTime = this.myAllTreasureShares.length > 0 ? this.myAllTreasureShares[this.myAllTreasureShares.length - 1].CreateTime : null
      const url = `/innovation/treasures/my-treasure-shares?UserUniqueId=${userUniqueId}&CreateTime=${CreateTime}`

      request('get', url).then(res => {
        if (res.length > 0) {
          this.myAllTreasureShares = this.myAllTreasureShares.concat(res)
          if (res.length < 10) {
            this.isAllMyAllTreasureSharesLoaded = true
          }
        } else {
          this.isAllMyAllTreasureSharesLoaded = true
        }
        this.$refs.loadMoreMyAllTreasureShares.onBottomLoaded()
      }).catch(err => {
        console.log(err)
      })
    },
    subsQuantity (itemIndex) {
      const currentQuantity = this.quantity[itemIndex] || 1
      if (currentQuantity > 1) {
        this.$set(this.quantity, itemIndex, currentQuantity - 1)
      }
    },
    addQuantity (itemIndex, maxSharePerUser) {
      const currentQuantity = this.quantity[itemIndex] || 1
      if (currentQuantity < maxSharePerUser) {
        this.$set(this.quantity, itemIndex, currentQuantity + 1)
      } else {
        Toast(this.$t('lang.treasure.tooManyErrorMessage'))
      }
    },
    onQuantityChange (itemIndex, maxSharePerUser, $event) {
      const quantity = parseInt($event.target.value)

      if (!Number.isInteger(quantity)) {
        Toast(this.$t('lang.treasure.invalidNumberMessage'))
        return
      }

      if (quantity > 0 && quantity < maxSharePerUser) {
        this.$set(this.quantity, itemIndex, quantity)
      } else {
        Toast(this.$t('lang.treasure.tooManyErrorMessage'))
      }
    },
    buy (treasureId, itemIndex) {
      const url = '/innovation/treasures/buy'
      const quantity = this.quantity[itemIndex] || 1
      const data = {
        UserUniqueId: this.userInfo.UserId,
        TreasureId: treasureId,
        Quantity: quantity
      }

      request('post', url, data).then(res => {
        const result = JSON.parse(res)
        if (result.Code === '0') {
          this.boughtQuantityInModal = result.Numbers.length
          this.boughtTicketsInModal = result.Numbers
          this.isBoughtResultModalShowing = true
          this.latestTreasures[itemIndex].IsCurrentUserBought = true
          this.fetchSoldSharesCount(treasureId, itemIndex)
        } else if (result.Code === '-1') {
          Toast(this.$t('lang.treasure.pleaseLoginMessage'))
        } else if (result.Code === '-2') {
          Toast(this.$t('lang.treasure.treasureDoesNotExistMessage'))
        } else if (result.Code === '-3') {
          Toast(this.$t('lang.treasure.doesNotOnSaleMessage'))
        } else if (result.Code === '-4') {
          Toast(this.$t('lang.treasure.tooManyErrorMessage'))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    gotoRoute (path) {
      this.$router.push(path)
    },
    closeBoughtResultModal () {
      this.isBoughtResultModalShowing = false
      this.boughtQuantityInModal = 1
      this.boughtTicketsInModal = []
    },
    showHistoryBoughtResultModal (MyNumbers, DrawNumber) {
      if (MyNumbers && MyNumbers.length > 0) {
        this.boughtTicketsInModal = MyNumbers
        this.drawNumberOfSelectedHistory = DrawNumber
        this.isHistoryBoughtResultModalShowing = true
      }
    },
    closeHistoryBoughtResultModal () {
      this.isHistoryBoughtResultModalShowing = false
      this.boughtTicketsInModal = []
      this.drawNumberOfSelectedHistory = null
    },
    fetchAddress () {
      const userUniqueId = this.userInfo.UserId

      request('post', '/innovation/account/getuserinfo', {
        userId: userUniqueId,
        isEditPage: false
      }).then(res => {
        this.myAddress = res.Address
      })
    },
    changeAddress () {
      const userUniqueId = this.userInfo.UserId
      request('put', '/innovation/account/updateuserinfo', {
        UserId: userUniqueId,
        Address: this.myAddress
      }).then(() => {
        Toast(this.$t('lang.treasure.saveAddressSuccess'))
      })
    },
    showTreasureIntro (intro) {
      if (intro) {
        Toast(intro)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .page {
    height: calc(100vh - 76px);
    padding-top: 56px;
    background: #171110;

    .tabList {
      display: flex;
      text-align: center;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      padding: 15px 5px 0 5px;
      .tab {
        padding: 0 5px 5px;
        font-size: 16px;
        color: #686868;
        flex: 1;
      }
      .tabSelected {
        color: #F6D9AA;
        line-height: 21px;
        font-weight: 500;
        border-bottom: 2px solid #F6D9AA;
      }
    }

    .latestTab {
      padding: 20px 5px 0;
      height: calc(100vh - 206px);
      overflow-y: scroll;
      position: relative;

      .helpIcon {
        position: absolute;
        right: 20px;
        top: 0;
      }

      .treasureItem {
        position: relative;
        margin-bottom: 16px;
        padding: 12px;
        height: 131px;
        background: #202020;
        border-radius: 8px;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

        .boughtTips {
          position: absolute;
          right: 0;
          top: 0;
          width: 48px;
          height: 20px;
          background: #18d7e3;
          color: #ffffff;
          font-size: 10px;
          line-height: 18px;
          text-align: center;
          border-radius: 0 8px;
        }

        .drawTime {
          font-size: 12px;
          line-height: 30px;
          color: #878787;
        }

        .details {
          display: flex;
          justify-content: space-between;

          img {
            width: 80px;
            height: 80px;
            border-radius: 3px;
          }

          .nameProgressBuy {
            width: 73%;

            .name {
              color: #ffffff;
              font-size: 14px;
              line-height: 17px;
            }

            .progress {
              .indicator {
                float: right;
                line-height: 30px;
                margin-left: 3px;
                color: #cccccc;
              }
            }

            .buy {
              display: flex;
              justify-content: space-between;
              align-items: center;
              line-height: 36px;

              div:first-of-type {
                display: flex;
                align-items: center;

                input {
                  width: 83px;
                  height: 30px;
                  margin: 0 6px;
                  color: #f0d3a1;
                  border: 1px solid #f0d3a1;
                  border-radius: 5px;
                  padding: 4px;
                  text-align: center;
                }

                .subs, .add {
                  width: 24px;
                  height: 24px;
                  font-size: 24px;
                  color: darkgrey;
                  background: none;
                  border: none;
                }
              }

              .buyButton {
                width: 70px;
                height: 30px;
                border: 1px solid #f0d3a1;
                border-radius: 4px;
                background: #f0d3a1;
                font-weight: 600;
              }
            }
          }
        }
      }

      .boughtResultModal {
        position: absolute;
        left: 12%;
        top: 12%;
        height: 344px;
        width: 300px;
        background: #202020;
        border-radius: 8px;
        padding: 10px;
        text-align: center;

        .title {
          font-size: 14px;
          color: #ffffff;
        }

        .tickets {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 230px;
          margin-top: 15px;
          overflow-y: scroll;

          .ticket {
            width: 216px;
            height: 54px;
            margin: 10px 0;
            text-align: center;
            line-height: 54px;
            background: url("../../assets/images/common/oneRupeeTreasureNumberBG.png");
            background-size: cover;
          }
        }

        .closeButton {
          width: 216px;
          height: 30px;
          border: 1px solid #f0d3a1;
          border-radius: 4px;
          background: #f0d3a1;
        }
      }
    }

    .historyTab {
      padding: 20px 5px 0;
      height: calc(100vh - 206px);
      overflow-y: scroll;
      position: relative;

      .treasureItem {
        position: relative;
        margin-bottom: 16px;
        padding: 12px;
        height: 131px;
        background: #202020;
        border-radius: 8px;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

        .boughtTips {
          position: absolute;
          right: 0;
          top: 0;
          width: 48px;
          height: 20px;
          font-size: 10px;
          line-height: 18px;
          text-align: center;
          border-radius: 0 8px;
        }
        .winningTips {
          background: #fb4138;
          color: #ffffff;
        }
        .losingTips {
          background: #ffffff;
          color: #000000;
        }

        .drawTime {
          font-size: 12px;
          line-height: 30px;
          color: #878787;
        }

        .details {
          display: flex;
          justify-content: space-between;

          img {
            width: 80px;
            height: 80px;
            border-radius: 3px;
          }

          .nameAndNumbers {
            width: 73%;

            .name {
              color: #ffffff;
              font-size: 14px;
              line-height: 17px;
            }

            .winningNumber {
              font-size: 14px;
              color: #f0d3a1;
              text-align: center;
              line-height: 44px;
            }

            .myNumbers {
              font-size: 12px;
              color: #cccccc;
            }
          }
        }
      }

      .boughtResultModal {
        position: absolute;
        left: 12%;
        top: 12%;
        height: 344px;
        width: 300px;
        background: #202020;
        border-radius: 8px;
        padding: 10px;
        text-align: center;

        .title {
          font-size: 14px;
          color: #ffffff;
        }

        .tickets {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 230px;
          margin-top: 15px;
          overflow-y: scroll;

          .ticket {
            width: 216px;
            height: 54px;
            margin: 10px 0;
            text-align: center;
            line-height: 54px;
            background-size: cover;
          }

          .lossTicket {
            background: url("../../assets/images/common/oneRupeeTreasureNumberBG.png");
          }

          .hitTicket {
            color: #ffffff;
            background: url("../../assets/images/common/oneRupeeTreasureNumberHitBG.png");
          }
        }

        .closeButton {
          width: 216px;
          height: 30px;
          border: 1px solid #f0d3a1;
          border-radius: 4px;
          background: #f0d3a1;
        }
      }
    }

    .myTreasureTab {
      padding: 0 5px 0;
      height: calc(100vh - 206px);
      overflow-y: scroll;

      .myTreasures {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 10px 10px 10px;

        .legend {
          width: 56%;
          height: 0;
          margin: 0 auto;
          padding: 5px 0;
          color: #ffffff;

          border-bottom: 20px solid #202020;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          position: relative;

          span {
            display: block;
            position: absolute;
            top: 20px;
            text-align: center;
            width: 100%;
          }
        }

        .table {
          padding: 10px 2px;
          background: #202020;
          border-radius: 8px;

          .header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: 12px;
            line-height: 22px;
            color: #888888;
            padding: 6px 2px;

            .drawTime {
              flex: 1 0 28%;
              text-align: left;
            }

            .myNumber {
              flex: 1 0 22%;
              text-align: center;
            }

            .treasure {
              flex: 1 0 28%;
              text-align: center;
            }

            .status {
              flex: 1 0 22%;
              text-align: right;
            }
          }

          .myTreasureItem {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: 12px;
            line-height: 22px;
            color: #ffffff;
            padding: 2px;

            .drawTime {
              flex: 1 0 28%;
              text-align: left;
            }

            .myNumber {
              flex: 1 0 22%;
              text-align: center;
            }

            .treasure {
              flex: 1 0 28%;
              text-align: center;
            }

            .status {
              flex: 1 0 22%;
              text-align: right;
              overflow-wrap: anywhere;
            }
          }
        }
      }

      .myAddress {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px;
        color: #ffffff;
        font-size: 12px;

        label {
          width: 54%;

          input {
            height: 30px;
            margin: 0 6px;
            color: #f0d3a1;
            border: 1px solid #f0d3a1;
            border-radius: 5px;
            padding: 4px;
            text-align: center;
          }
        }

        .submitButton {
          width: 70px;
          height: 30px;
          border: 1px solid #f0d3a1;
          border-radius: 4px;
          background: #f0d3a1;
          font-weight: 600;
        }
      }

      .myHistory {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 10px 10px 10px;

        .legend {
          width: 56%;
          height: 0;
          margin: 0 auto;
          padding: 5px 0;
          color: #ffffff;

          border-bottom: 20px solid #202020;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          position: relative;

          span {
            display: block;
            position: absolute;
            top: 20px;
            text-align: center;
            width: 100%;
          }
        }

        .table {
          padding: 10px 2px;
          background: #202020;
          border-radius: 8px;

          .header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: 12px;
            line-height: 22px;
            color: #888888;
            padding: 6px 2px;

            .drawTime {
              flex: 1 0 28%;
              text-align: left;
            }

            .myNumber {
              flex: 1 0 22%;
              text-align: center;
            }

            .treasure {
              flex: 1 0 28%;
              text-align: center;
            }

            .status {
              flex: 1 0 22%;
              text-align: right;
            }
          }

          .myTreasureItem {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: 12px;
            line-height: 22px;
            color: #ffffff;
            padding: 2px;

            .drawTime {
              flex: 1 0 28%;
              text-align: left;
            }

            .myNumber {
              flex: 1 0 22%;
              text-align: center;
            }

            .treasure {
              flex: 1 0 28%;
              text-align: center;
            }

            .status {
              flex: 1 0 22%;
              text-align: right;
              overflow-wrap: anywhere;
            }
          }
          .win {
            color: #CC2500!important;
          }
          .loss {
            color: #686868!important;
          }
        }
      }

    }

    .emptyTips {
      display: flex;
      justify-content: center;
    }

    /deep/ .mt-progress-runway {
      background-color: #4d4840;
    }

    /deep/ .mt-progress-progress {
      background-color: #f0d3a1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Treasure/index.vue